import {useFragment} from "react-relay";
import {AccountCodeColumnProps} from "./account-code-column.types";
import {ACCOUNT_CODE_FRAGMENT} from "./account-code-column.graphql";
import {accountCodeColumn_Fragment$key} from "../../../../__generated__/accountCodeColumn_Fragment.graphql";

export const AccountCodeColumnComponent  = ({ userFragmentRef }: AccountCodeColumnProps) => {
    const user = useFragment<accountCodeColumn_Fragment$key>(ACCOUNT_CODE_FRAGMENT, userFragmentRef);

    return (
        <div>
             {user.extension?.accountCode}
        </div>
    );
};
